<template>
  <div class="columns" :class="className">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    valign: {
      type: String,
      default: '',
    }
  },
  computed: {
    className() {
      return {
        'v-centered': !!this.valign.length
      }
    }
  }
}
</script>

<style lang="scss">
.columns {
  display: flex;
  flex-wrap: wrap;

  &.v-centered {
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// Columns.vue?9180bf32